// define variables here

function formatNumber(number, decimals = 2) {
    number = parseFloat(number).toFixed(decimals);

    let  str = number + '',
        x = str.split('.'),
        x1 = x[0],
        x2 = x.length > 1 ? ',' + x[1] : '',
        rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }

    return x1 + x2;
}

$.fn.inputFilter = function(inputFilter) {
    // Restricts input for each element in the set of matched elements to the given inputFilter
    // https://stackoverflow.com/questions/995183/how-to-allow-only-numeric-0-9-in-html-inputbox-using-jquery
    return this.on('input keydown keyup mousedown mouseup select contextmenu drop', function() {
        if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty('oldValue')) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
    });
};

$.fn.allInputsContainValues = function () {
    let $step = $(this);

    if (!$step.hasClass('step--active')) return false;

    let condition = false,
        inputCount = 0,
        inputFilledCount = 0,
        inputNames = {};

    $step.find('input').each(function () {
        inputNames[$(this).attr('name')] = true;
    });

    $.each(inputNames, function () {
        inputCount++;
    });

    $step.find('input').each(function () {
        let type = $(this).attr('type');

        if ('radio' === type || 'checkbox' === type) {
            if ($(this).is(':checked')) {
                inputFilledCount++;
            }

        } else {
            if ($(this).val()) {
                inputFilledCount++;
            }
        }
    });

    if (inputCount === inputFilledCount) {
        condition = true;
    }

    return condition;
}

$.fn.showNextStep = function () {
    let $wizard = $(this);

    if (!$wizard.hasClass('wizard')) return false;

    let $stepActive = $('.step.step--active', this);

    if ($stepActive.length > 0) {
        let $stepNext = $stepActive.nextAll('.step:not(.step--hidden)').first();

        if ($stepNext.length > 0) {
            if ($stepActive.allInputsContainValues()) {
                $stepActive.removeClass('step--active');
                $stepNext.addClass('step--active').stop().slideDown(300);

                let $wizardMain = $wizard.find('.wizard__main');

                // scroll to next step on change
                setTimeout(function () {
                    let scrollPosition = $wizardMain.offset().top + $wizardMain.outerHeight() + parseInt($wizard.css('padding-top')) - viewport().height;

                    if ($stepNext.hasClass('step--form')) scrollPosition = $stepNext.offset().top - $('.masthead').height();

                    $('html, body').stop().animate({
                        scrollTop: scrollPosition
                    }, 300);
                }, 300);

                if ($stepNext.hasClass('step--form')) {
                    // fire GTM event on wizard complete
                    let gtm_event = 'Wizard complete',
                        page_url = $(location).attr('href');

                    const event = {
                        'event': 'gtm_event',
                        'event_label': gtm_event,
                        'event_url': page_url
                    }

                    if (typeof dataLayer !== 'undefined') {
                        dataLayer.push(event);
                    }
                }
            }
        }
    }
}

$.fn.setStepNumbers = function () {
    let $wizard = $(this);

    if (!$wizard.hasClass('wizard')) return false;

    let total_steps = $('.wizard__steps .step:not(.step--hidden)', this).length;

    // set total steps
    $('[data-wizard-value="total-steps"]', this).text(total_steps);

    // set individual step numbers
    $('.wizard__steps .step:not(.step--hidden) .step__number', this).each(function () {
        let $step = $(this).closest('.step'),
            index = $step.index() + 1;

        $step.prevAll('.step--hidden').each(function () {
            index--;
        });

        $('[data-wizard-value="step-number"]', this).text(index);
    });
}

$.fn.populateFormFields = function () {
    let $wizard = $(this);

    if (!$wizard.hasClass('wizard')) return false;

    let $form = $wizard.find('.wizard__form');

    if ($form.length < 1) return false;

    $wizard.find('.step:not(.step--form)').each(function () {
        $(this).find('input, textarea').each(function () {
            let name = $(this).attr('name'),
                value;

            if ('checkbox' === $(this).attr('type')) {
                value = [];
                value.push($wizard.find('input[name="' + name + '"]:checked').closest('.custom-checkbox').find('.custom-checkbox__title').text().trim());
            } else if ('radio' === $(this).attr('type')) {
                value = $wizard.find('input[name="' + name + '"]:checked').closest('.custom-radio').find('.custom-radio__title').text().trim();
            } else {
                value = $(this).val();
            }

            // send to contact form (hidden input with class)
            if ($(this).closest('.step').hasClass('step--hidden') || $(this).closest('.step').is('[data-conditional-state="hidden"]')) {
                $form.find('.wizard-' + name + ' input').val(''); // clear hidden step field values
            } else {
                $form.find('.wizard-' + name + ' input').val(value);
            }
        });
    });
}

$.fn.wizardInit = function () {
    let $wizard = $(this);

    if (!$wizard.hasClass('wizard')) return false;

    // set active state to first step
    if ($('.step.step--active', this).length < 1) {
        $('.step', this).first().addClass('step--active');
    }

    // Restrict input to digits by using a regular expression filter.
    $('input[inputmode="numeric"]', this).inputFilter(function(value) {
        return /^\d*$/.test(value);
    });

    // focus input when clicking elements next to it inside wrapper
    $('.field__input-container', this).on('click', function () {
        $('input', this).focus();
    });

    // select all in input when focussing
    $('input', this).on('focus', function () {
        this.select();
    });

    let gtm_event_label = 'Wizard start';

    if ($wizard.hasClass('wizard--price')) gtm_event_label = 'Wizard price start';
    if ($wizard.hasClass('wizard--vacancy')) gtm_event_label = 'Wizard vacancy start';

    // fire GTM event on wizard start
    $('.step:first-child input', this).on('change', function () {
        if ($(this).closest('.step').hasClass('step--active')) {
            let page_url = $(location).attr('href');

            const event = {
                'event': 'gtm_event',
                'event_label': gtm_event_label,
                'event_url': page_url
            }

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(event);
            }
        }
    });

    $('input', this).on('change update', function () {
        $wizard.runWizard();
        $wizard.setStepNumbers();
        $wizard.showNextStep();
    });

    $wizard.runWizard();
    $wizard.setStepNumbers();
}

$.fn.runWizard = function () {
    let $wizard = $(this);

    if (!$wizard.hasClass('wizard')) return false;

    let $steps = $('.wizard__steps .step', this);

    if ($wizard.hasClass('wizard--price')) {
        let $result = $('.wizard__result', this);

        $steps.each(function () {
            let stepID = $(this).data('step-id'),
                $fields = $('.step__fields .field', this);

            if ($fields.length > 0) {
                $fields.each(function () {
                    let $field = $(this),
                        fieldName = $('input', this).first().attr('name'),
                        inputType = $('input', this).first().attr('type'),
                        summaryLabel = $(this).data('summary-label'),
                        $summaryValue = $result.find('[data-wizard-field-value="field-' + fieldName + '"]'),
                        $summaryValueWrapper = $summaryValue.closest('.wizard__data-expand');

                    if (typeof summaryLabel !== 'undefined' && $summaryValueWrapper.length > 0) {
                        if ('radio' === inputType) {
                            let value = $field.find('input:checked').val();

                            if (typeof value !== 'undefined') {
                                if (value.length > 1) {
                                    $summaryValueWrapper.stop().slideDown(150);
                                    $summaryValue.text($field.find('input:checked ~ .custom-radio__inner .custom-radio__title').text());
                                } else {
                                    if (value == 1) {
                                        $summaryValueWrapper.stop().slideDown(150);
                                    } else {
                                        $summaryValueWrapper.stop().slideUp(150);
                                    }
                                }
                            }
                        } else {
                            let value = $field.find('input').val();

                            if (typeof value !== 'undefined' && value) {
                                $summaryValueWrapper.stop().slideDown(150);
                                $summaryValue.text(value);
                            } else {
                                $summaryValueWrapper.stop().slideUp(150);
                                $summaryValue.text('');
                            }
                        }
                    }
                });
            }
        });
    }

    if ($wizard.hasClass('wizard--vacancy')) {
        let totalSteps = $wizard.find('.step:not(.step--form)').length,
            totalScore = 0, // percentage
            $formStep = $wizard.find('.step.step--form');

        $steps.each(function () {
            let $checkedInput = $(this).find('input:checked');

            if ($checkedInput.length > 0) {
                let inputVal = parseFloat($(this).find('input:checked').val()); // can be 1, 0 or 0.5

                // add percentage based on value
                totalScore += inputVal * (1 / totalSteps * 100);
            }
        });

        totalScore = Math.round(totalScore);

        if (totalScore < 0) totalScore = 0;
        if (totalScore > 100) totalScore = 100;

        if ($formStep.length > 0) {
            $formStep.find('.progress-circle__value').text(totalScore + '%');
            $formStep.find('.progress-circle__gauge-arc').css('stroke-dasharray', (329/100 * totalScore) + ', 329');

            if (totalScore < 60) {
                $formStep.find('.step__header-variant--low').show().siblings('.step__header-variant').hide();
            } else if (totalScore >= 60 && totalScore < 80) {
                $formStep.find('.step__header-variant--medium').show().siblings('.step__header-variant').hide();
            } else if (totalScore >= 80) {
                $formStep.find('.step__header-variant--high').show().siblings('.step__header-variant').hide();
            }
        }
    }

    $wizard.populateFormFields();
}

$('.wizard').each(function() {
    $(this).wizardInit();
});
